import { generatePath } from 'react-router-dom';
import type { CanBeVoidIfOnlyOptional } from '~/types/helper.types';

class Path<Params extends { [K in keyof Params]?: string } = void> {
  constructor(public readonly path: string) {}

  getPath = (
    matchParams: CanBeVoidIfOnlyOptional<Params>,
    search?: string
  ): string => {
    const newPath = generatePath(this.path, matchParams as Params);
    return newPath.concat(search || '');
  };
}

export default Path;
